<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading> -->
@if (showDelayedLoadingState && (eventListReady$ | async) === false) {
  <app-loading-state titleKey="common.loadingData" [page]="true" [delayMs]="0"></app-loading-state>
}

@if (eventListReady$ | async) {
<app-screen-shell contentWidth="standard" contentInset="page" [contentClass]="''" [showHeader]="false">

  <div *ngIf="!creatingNewEvent">

    <p *ngIf="joinMessage" class="h6 text-center">{{joinMessage}}</p>
    <p *ngIf="discoveryLocationMissing && !isMyMatchesClicked" class="alert alert-info py-2" role="status">{{ 'events.locationDiscoveryPrompt' | translate }}</p>

    <div class="match-filter mb-3">
      <div class="match-filter-tabs" role="toolbar" [attr.aria-label]="'events.matches' | translate">
        <button type="button" class="match-filter-tab my-matches"
          [class.is-active]="isMyMatchesClicked"
          [attr.aria-pressed]="isMyMatchesClicked"
          (click)="filterEvents('myMatches')">{{ 'events.myMatchesShort' | translate }}</button>
        <button type="button" class="match-filter-tab sos-matches"
          [class.is-active]="isSosMatchesClicked"
          [attr.aria-pressed]="isSosMatchesClicked"
          (click)="filterEvents('sosMatches')">{{ 'events.sosMatchesShort' | translate }} <span *ngIf="sosEvents.length" class="badge">{{ sosEvents.length }}</span></button>
        <button type="button" class="match-filter-tab all-matches"
          [class.is-active]="isAllMatchesClicked"
          [attr.aria-pressed]="isAllMatchesClicked"
          (click)="filterEvents('allMatches')">{{ 'events.allMatchesShort' | translate }}</button>
        <button type="button" class="match-filter-tab match-filter-add"
          [attr.aria-label]="'events.newMatch' | translate"
          [title]="'events.newMatch' | translate"
          (click)="createNewEvent()">
          <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <ng-container *ngIf="eventListReady$ | async">
      <div *ngIf="!listError && events.length == 0 && isAllMatchesClicked" class="matches match-empty-state animated fadeIn">
        <div class="match-empty-icon" aria-hidden="true"><i [class]="'locations.location' | nogoshIcon"></i></div>
        <h2 class="m-0">{{ (discoveryLocationMissing ? 'catchUp.setCity' : 'events.noMatches') | translate }}</h2>
        <p *ngIf="discoveryLocationMissing" class="text-nogosh-grey3 mt-2">
          {{ 'events.locationDiscoveryPrompt' | translate }}
          <a [routerLink]="['/player-detail', false]" [queryParams]="{section: 'location', returnTo: 'event-list'}">{{ 'events.addCity' | translate }}</a>
        </p>
      </div>

      <div *ngIf="!listError && sosEvents.length == 0 && isSosMatchesClicked" class="matches match-empty-state animated fadeIn">
        <div class="match-empty-icon" aria-hidden="true"><i [class]="'match.sos' | nogoshIcon"></i></div>
        <h2 class="m-0">{{ 'events.noSosMatches' | translate }}</h2>
      </div>

      <div *ngIf="!listError && myEvents.length == 0 && isMyMatchesClicked" class="matches match-empty-state animated fadeIn">
        <div class="match-empty-icon" aria-hidden="true"><i [class]="'match.soccer' | nogoshIcon"></i></div>
        <h2 class="m-0">{{ 'events.joinOrStart' | translate }}</h2>
      </div>

      <div *ngIf="listError" class="alert alert-danger" role="alert">{{ 'errors.generic' | translate }} <button class="btn btn-sm btn-outline-primary" (click)="retryList()">{{ 'common.tryAgain' | translate }}</button></div>
      <div *ngIf="events.length > 0" class="match-home-grid" [class.single-match]="events.length === 1">
        <ng-container *ngFor="let event of events; let index = index; trackBy: trackHomeEvent">
        <h2 *ngIf="mySectionTitle(index) as title" class="match-home-section-title">{{ title | translate }} <span class="badge">{{ mySectionCount(index) }}</span></h2>
        <app-match-home [event]="event" [chat]="homeChat(event)" [busy]="loading || attendanceSaving || teamSaving" (teamSaving)="onTeamSaving($event)" (candidate)="homeCandidate(event, $event)" (attendance)="homeAttendance(event, $event)" (action)="homeAction(event, $event)" (player)="homePlayer(event, $event)"></app-match-home>
        </ng-container>
      </div>
    </ng-container>
  </div>
</app-screen-shell>
}
